import { Tooltip } from '@/app/components/Tooltip';
import CopyIcon from '/public/icons/copy.svg';

export const CopyTooltip = () => {
  return (
    <Tooltip
      content={
        <div className="relative inline-block">
          <div className="relative bg-white text-gray-800 text-sm px-3 py-1.5 rounded-md border border-gray-200">
            <span className="text-body-small text-black">Copy to clipboard</span>
            <div className="absolute -bottom-[6.5px] left-1/2 -translate-x-1/2 w-3 h-3 -rotate-45 bg-white border-l border-b border-gray-200"></div>
          </div>
        </div>
      }
      placement="top"
      strategy="fixed"
    >
      <CopyIcon className="w-5 h-5 stroke-current text-grey-700" />
    </Tooltip>
  );
};
